"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityDivider = exports.EntityDividerDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var cell_label_1 = require("../elements/cell-label");
var badge_1 = require("../elements/badge");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var entity_bubble_image_1 = require("./entity-bubble-image");
var router_1 = require("@reach/router");
exports.EntityDividerDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 48px;\n    position: relative;\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    font-size: ", ";\n    color: ", ";\n  "], ["\n    height: 48px;\n    position: relative;\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    font-size: ", ";\n    color: ", ";\n  "])), theme_1.theme.FONT_SIZE(13), theme_1.theme.COLOR('dark'))
});
var LineStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    width: 100%;\n    top: 50%;\n    margin: 0;\n    border: none;\n    border-bottom: 1px solid ", ";\n  "], ["\n    position: absolute;\n    width: 100%;\n    top: 50%;\n    margin: 0;\n    border: none;\n    border-bottom: 1px solid ", ";\n  "])), theme_1.theme.COLOR('line-mid'))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    z-index: 20;\n    margin: 0;\n    font-weight: 500;\n    display: flex;\n    margin-left: ", ";\n    align-items: center;\n    flex-direction: row;\n    position: relative;\n    border: 1px solid ", ";\n    border-radius: 50px;\n    background: ", ";\n    padding: 0 ", " 0 ", ";\n    line-height: 1.35em;\n    height: 46px;\n    font-size: 1em;\n    text-transform: capitalize;\n    cursor: pointer;\n\n    &:hover {\n      border: 1px solid ", ";\n    }\n  "], ["\n    z-index: 20;\n    margin: 0;\n    font-weight: 500;\n    display: flex;\n    margin-left: ", ";\n    align-items: center;\n    flex-direction: row;\n    position: relative;\n    border: 1px solid ", ";\n    border-radius: 50px;\n    background: ", ";\n    padding: 0 ", " 0 ", ";\n    line-height: 1.35em;\n    height: 46px;\n    font-size: 1em;\n    text-transform: capitalize;\n    cursor: pointer;\n\n    &:hover {\n      border: 1px solid ", ";\n    }\n  "])), theme_1.theme.UNIT(3), theme_1.theme.COLOR('line-mid'), theme_1.theme.COLOR('app-chrome'), theme_1.theme.UNIT(4), theme_1.theme.UNIT(2), theme_1.theme.COLOR('primary'))
});
var LabelAndNameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n  "], ["\n    display: flex;\n    flex-direction: row;\n  "])))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-left: ", ";\n  "], ["\n    margin-left: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var NameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    font-size: 1em;\n    margin-left: ", ";\n  "], ["\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    font-size: 1em;\n    margin-left: ", ";\n  "])), theme_1.theme.UNIT(1))
});
var BadgeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-left: ", ";\n  "], ["\n    margin-left: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Line: styled_components_1.default.hr(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), LineStyles),
  Body: styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Image: (0, styled_components_1.default)(entity_bubble_image_1.EntityBubbleImage)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  LabelAndName: styled_components_1.default.span(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), LabelAndNameStyles),
  Label: (0, styled_components_1.default)(cell_label_1.CellLabel)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Name: styled_components_1.default.span(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Badge: (0, styled_components_1.default)(badge_1.Badge)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles)
};
var EntityDivider = function (props) {
  var className = props.className,
    children = props.children,
    badge = props.badge,
    entity = props.entity;
  var defn = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var bodyOnClick = function () {
    (0, router_1.navigate)(defn.to(entity.slug));
  };
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Line, null), react_1.default.createElement(My.Body, {
    onClick: bodyOnClick
  }, react_1.default.createElement(My.Image, {
    entity: entity,
    size: 32
  }), react_1.default.createElement(My.Label, null, defn.label, ":"), react_1.default.createElement(My.Name, null, entity.name), badge && react_1.default.createElement(My.Badge, null, badge)));
};
exports.EntityDivider = EntityDivider;
exports.EntityDivider.defaultProps = exports.EntityDividerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;